/* eslint-disable */

export default {
  /**
   * app credentials
   */
  app: {
    dtpApiBaseUrl: process.env.REACT_APP_BASEURL,
    dtpSockerServerBaseUrl: process.env.REACT_APP_SOCKET_SERVER_BASEURL
  },

  /**
   * googl credentials
   */
  google: {
    oauth: {
      clientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID
    }
  }
} 